import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  menuItem: {
    textTransform: 'capitalize',
  },
  itemIcon: {
    minWidth: 'fit-content',
    marginRight: theme.spacing(1),
  },
  geoEventOption: {
    display: 'flex',
    // alignItems: 'center',
    height: 38,
  },
  geoEventIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1.5),
  },
}));
